import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-table',
  templateUrl: './time-table.component.html',
  styleUrls: ['./time-table.component.scss']
})
export class TimeTableComponent implements OnInit {
  activeTimetableTab: string = '2024-25';
  activeLessonPlanTab: string = '2023-24';

  constructor() { }
  ngOnInit(): void { }

  setActiveTimetableTab(tab: string) {
    this.activeTimetableTab = tab;
  }

  setActiveLessonPlanTab(tab: string) {
    this.activeLessonPlanTab = tab;
  }
}
